import { render, staticRenderFns } from "./tipTimeLine.vue?vue&type=template&id=8552b504&scoped=true"
import script from "./tipTimeLine.vue?vue&type=script&lang=js"
export * from "./tipTimeLine.vue?vue&type=script&lang=js"
import style0 from "./tipTimeLine.vue?vue&type=style&index=0&id=8552b504&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8552b504",
  null
  
)

export default component.exports